import { InfoCircleOutlined } from '@ant-design/icons'
import { useAppSelector } from '../../../../redux/hooks.ts'
import { selectThemeStyle } from '../../../../features/setting/setting.slice.ts'
import Tooltip from 'antd/es/tooltip/index'
import { useIsMobile } from '../../../../common/hooks/use-is-mobile.ts'

interface TotalReturnPctDependentHeaderProps {
  displayName?: string
}

export const TotalReturnPctDependentHeaderComponent = ({
  displayName,
}: TotalReturnPctDependentHeaderProps) => {
  const themeStyle = useAppSelector(selectThemeStyle)
  const isMobile = useIsMobile()

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: themeStyle.marginXXS,
        width: '100%',
      }}
    >
      <span>{displayName}</span>
      {!isMobile && (
        <span
          onClick={(event) => event.stopPropagation()}
          style={{ display: 'inline-flex', alignItems: 'center' }}
        >
          <Tooltip title={'Total PnL / Max Investment'}>
            <InfoCircleOutlined
              style={{
                color: themeStyle.colorIcon,
                cursor: 'pointer',
              }}
            />
          </Tooltip>
        </span>
      )}
    </div>
  )
}